import { customFetch, FetchParams, DEFAULT_API_URL } from '../../common';

export const getSkuData = async ({
  fetchFn,
  params,
}: {
  fetchFn: typeof fetch;
  params: Inventory.SkuDataFetchOptions & FetchParams;
}): Promise<Inventory.SkuDataObject> => {
  const {
    gtin,
    country,
    merchGroup,
    callerId,
    fetchParams: { timeout, baseUrl = DEFAULT_API_URL } = {},
  } = params;
  const path = 'merch/skus/v2';
  const url = `${baseUrl}/${path}/?filter=gtin(${gtin})&filter=country(${country})`;

  const skuDataResponse = await customFetch({
    fetchFn,
    options: {
      headers: {
        'Content-Type': 'application/json',
        'nike-api-caller-id': callerId,
      },
      method: 'GET',
      path,
      timeout,
    },
    url,
  });
  const skuData = await skuDataResponse.json();
  return skuData?.objects?.find(
    (skuDataObject: Inventory.SkuDataObject) =>
      skuDataObject.merchGroup === merchGroup,
  );
};
